import { Component } from '@angular/core';

@Component({
  selector: 'uni-box-footer-item',
  templateUrl: './uni-box-footer-item.component.html',
  styleUrls: ['./uni-box-footer-item.component.scss'],
})
export class UniBoxFooterItemComponent {}
